<template>
  <div>
      <v-img
          contain
          :lazy-src="localImage"
          :src="localImage"
          :max-width="maxWidth"
          :max-height="maxHeight"
          @click="dialogImage=true; imageURL=value"
      ></v-img>
    <v-dialog
        v-if="!view"
        v-model="dialogImage"
        width="600"
    >
      <v-card>
        <v-toolbar height="32">
          <a :href="value" target="_blank">
            <v-icon small>mdi-image-outline</v-icon>
          </a>
          <v-sheet
              width="900"
              v-if="!readonly">
            <v-edit-dialog
                @save="$emit('input', imageURL)"
                @open="imageURL = value"
                large
            >
              <template v-slot:input>
                <BaseFieldString v-model="imageURL" class="mt-3"></BaseFieldString>
              </template>
              <v-icon small>mdi-image-edit-outline</v-icon>
            </v-edit-dialog>
          </v-sheet>
        </v-toolbar>
        <v-img
            contain
            :lazy-src="localImage"
            :max-height="heightLarge"
            :max-width="widthLarge"
            :src="localImage"
            class="mx-0"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import BaseFieldString from "@/components/Base/BaseFieldString";

export default {
  name: 'BaseImageCard',
  inheritAttrs: false,
  props: {
    value: {default: null},
    maxHeight: {default: null},
    maxWidth: {default: null},
    heightLarge: {default: 600},
    widthLarge: {default: 600},
    readonly: {type: [Boolean], default: false},
    view: {type: [Boolean], default: false},
  },

  components: {
    BaseFieldString,
  },

  computed: {
    localImage() {
      if (!!this.value)
        return this.value
      else
        return "/static/images/no-image.png"
    },
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {
      dialogImage: false,
      imageURL: null,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
